import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE_URL });

// Aggiunge automaticamente il token Bearer ad ogni richiesta
api.interceptors.request.use(config => {
  const token = localStorage.getItem("ve_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Se il server risponde 401, rimuove il token (sessione scaduta)
api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("ve_token");
      window.location.href = "/auth";
    }
    return Promise.reject(err);
  }
);

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`/clients/${id}`);
export const bulkDeleteClients = (ids) => api.post("/clients/bulk-delete", { client_ids: ids });
export const getClientAppointments = (id) => api.get(`/clients/${id}/appointments`);

// Appointments
export const getAppointments = (params) => api.get('/appointments', { params });
export const getTodayAppointments = () => api.get('/appointments/today');
export const createAppointment = (data) => api.post('/appointments', data);
export const recordOutcome = (id, data) => api.post(`/appointments/${id}/outcome`, data);
export const revokeOutcome = (id) => api.post(`/appointments/${id}/revoke`);
export const updateAppointment = (id, data) => api.patch(`/appointments/${id}`, data);
export const deleteAppointment = (id) => api.delete(`/appointments/${id}`);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
